/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const PrimaryContact = z.object({
  contactType: z.enum([
    'UNKNOWN',
    'PRODUCT_MANAGER',
    'PROJECT_MANAGER',
    'ACCOUNT_MANAGER',
    'DELIVERY_MANAGER',
    'SOLUTION_ARCHITECT',
    'ENGINEER',
    'LIVEOPS',
    'BUSINESS_DEVELOPMENT',
    'FINANCE',
    'EXECUTIVE_SPONSOR',
    'EXECUTIVE',
    'EMPLOYEE'
  ]),
  email: z.string().nullish(),
  id: z.string().nullish(),
  idType: z.enum(['user', 'email']),
  tags: z.array(z.string()),
  userId: z.string().nullish()
})

export interface PrimaryContact extends z.TypeOf<typeof PrimaryContact> {}
